import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef,
  ChangeDetectionStrategy
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { gridColumnHeadingModel } from "../models/grid-column-heading-model";
import { gridDataModel } from "../models/grid-data-model";
import paginate from "../models/paginate";
import { AddSubscription } from "../services/add-subscription.service";
import { AssessmentService } from '../services/assessment.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgbToDatePipe } from "../pipes/ngb-to-date.pipe";
import { cloneDeep } from 'lodash';
import { UserRolesService } from "../services/user-roles.service";
import { AuditTrail, SecurityData, UserSecurityDetailCriteria } from "../models/security-model";
import { UserRoleDetails } from "../models/user-role-details";
import { SecurityService } from "../services/security.service";
import { MasterDataService } from '../services/masterdata.service';
import { Console } from "console";
import { DateToNgbPipe } from "../pipes/date-to-ngb.pipe";
import { catchError, debounceTime, map, Observable, of, Subject, switchMap } from "rxjs";

@Component({
    selector: "app-smart-data-grid",
    templateUrl: "./smart-data-grid.component.html",
    styleUrls: ["./smart-data-grid.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SmartDataGridComponent implements OnInit, OnChanges {
  public isDesc: boolean = false; // for sorting

  // Below variables for pagination
  public currentPage = 1;
  public pages: Array<number>; //list of pages for pagination
  public startIndex: number;
  public endIndex: number;
  /*public pageSize = 10; //row per page*/
  public maxPages = 100;
  public itemsPerPage: any;
  public clonedSampleData: any;
    public pagination: any;
    public sortDir: any;
    public colName: string;
    public sortFlag: boolean = false;
    public profileInfoData: any;
    public selectedRow: SecurityData;
    public auditTrailsOriginal: Array<AuditTrail> = [];
    public auditTrailsOriginalParsed: Array<any> = [];
    public auditTrailsTemp: Array<any> = [];
    public auditTrailsAll: Array<any> = [];
    public todaysDate: Date = new Date();
    public formattedDate: string = `${this.todaysDate.getMonth() + 1}/${this.todaysDate.getDate()}/${this.todaysDate.getFullYear()} ${this.todaysDate.getHours()}:${this.todaysDate.getMinutes()}:${this.todaysDate.getSeconds()}`;
    public maxDate: any;
    public loggedInUserDetails: UserRoleDetails;
    public profileFormSubmitted: boolean = false;
    public userRoleId: number;
    public disableTopics: boolean = false;
    public countries: any = [];
    public levels: any = [];
    public functions: any = [];
    public selectAllTopicsCheckbox: boolean = false;
    public selectAllRolesCheckbox: boolean = false;
    public disableMdrFields: boolean = false;
    public existingCertificationDate : any;
    UserTopicsCheckbox: any;
    UserRolesCheckbox: any;
    selectedRowIndex: number | null = null;
  @Input() gridNoResultMsg: string = "No records found";

  // Below variables are for communication through grid and app component
  @Input() sampleColumns: any;
  @Input() sampleData: any;
  @Input() allowCheckbox: boolean;
  @Input() allowPagination: boolean;
  @Input() isClientSidePagination: boolean;
  @Input() iseventRegistered: boolean;
  @Input() totalRecord: number;
  @Input() pageSize: number;
  @Input() isSubscriptionModule: boolean; // No sorting feature for Subscription module
  @Input() isAddSubscriptionModule: boolean;
    @Input() allowSelectAllCheckbox: boolean = true;
    @Input() selectAllChecked: boolean;
    @Input() selectAllCheckboxDisabled: boolean = false;
    @Input() rowCheckboxDisabled: boolean = false;
    @Input() onSearchClicked: boolean = false;
    @Input() isInfiniteScroll: boolean = false;
    @Input() showAllUsersData: boolean = false;
    @Input() auditTrails: Array<AuditTrail>;
    @Input() userSecurityDetailCriteria: UserSecurityDetailCriteria;
  @Input() LinkType: string;
  @Output() informParentComponent = new EventEmitter();
  @Output() handlePageChangeEvent = new EventEmitter();
  @Output() checkboxChangeEvent = new EventEmitter();
  @Output() selectAllCheckbox = new EventEmitter();
  @Output() emitRowSelectedEvent = new EventEmitter();
  @Output() editClickEvent = new EventEmitter(); 
  @Output() filterData = new EventEmitter();
  @Output() informCheckboxClick = new EventEmitter();
  @Output() emitParentEmailClickEvent = new EventEmitter();
  @Output() emitParentPDFClickEvent = new EventEmitter(); 
  @Output() onProfileInfoSave = new EventEmitter();
    oldProperty: any;
    private filterSubject = new Subject<{ event: any, columnName: string }>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private addSubscriptionService: AddSubscription,
    private assessmentService: AssessmentService,
    private modalService: NgbModal,
    private ngbToDatePipe: NgbToDatePipe,
    private userRoleService: UserRolesService,
    private securityService: SecurityService,
    private masterDataService: MasterDataService,
    private dateToNgbPipe: DateToNgbPipe
  ) {}

    ngOnInit() {
        if (this.masterDataService.masterData != undefined) {
            this.countries = [];
            this.levels = [];
            this.functions = [];
            if (this.masterDataService.masterData && this.masterDataService.masterData.Countries && this.masterDataService.masterData.Countries.length > 0) {
                this.countries = this.masterDataService.masterData.Countries;
                this.levels = this.masterDataService.masterData.JobLevels;
                this.functions = this.masterDataService.masterData.ServiceFunctions;
            }
        }
        else {
            this.masterDataService.getMasterDataDetails().subscribe((res) => {
                this.countries = [];
                this.levels = [];
                this.functions = [];
                if (this.masterDataService.masterData && this.masterDataService.masterData.Countries && this.masterDataService.masterData.Countries.length > 0) {
                    this.countries = this.masterDataService.masterData.Countries;
                    this.levels = this.masterDataService.masterData.JobLevels;
                    this.functions = this.masterDataService.masterData.ServiceFunctions;
                }
            })
        }
    if (this.sampleData && this.sampleData.length > 0) {
        this.clonedSampleData = this.sampleData.map((x) => Object.assign({}, x));
        
       
      this.calculateIndexes();
      // to cehck whether pagination is server side or client side
      if (
        this.isClientSidePagination &&
        this.sampleData &&
        this.sampleData.length
      ) {
        this.setPage(this.currentPage);
      } else {
        this.itemsPerPage = this.clonedSampleData;
      }
    } else {
      this.sampleData = [];
      this.itemsPerPage = [];
      this.clonedSampleData = [];
    }

    this.userRoleService.getUserRoles().subscribe((res: UserRoleDetails) => {
      this.loggedInUserDetails = res;
    });
    this.userRoleService.getUserRoleID().subscribe((id) => {
        this.userRoleId = Number(id);
    });
this.declarefilterSubject();
        
  }
  declarefilterSubject()
  {
    this.filterSubject.pipe(
      debounceTime(300),
      map(({ event, columnName }) => ({
        value: event?.target?.value,
        columnName: columnName,
        columnData: {
          "Name": $("#Name").val(),
          "Level": $("#Title").val(),
          "Email": $("#Email").val(),
          "Location": $("#Country").val(),
          "Function": $("#ServiceFunction").val(),
          "CertificationlevelID": Number($("#CertificationlevelID").val() ? $("#CertificationlevelID").val() : null),
          "SortBy": this.colName,
          "SortOrder": this.sortDir == 0 ? "" : this.sortDir == 1 ? "DESC" : "ASC",
          "PageNumber": 1,
          "PageSize": this.pageSize
        }
      })),
      switchMap(data => {
        // You can add any additional processing or API calls here
        return new Observable(observer => {
          observer.next(data);
          observer.complete();
        }).pipe(
          catchError(error => {
            console.error(error);
            return of(null);
          })
        );
      })
    ).subscribe(data => {
      if (data) {
        this.filterData.emit(data);
      }
    });
  }

    ngOnChanges() { 
    if (this.sampleData && this.sampleData.length > 0) {
      this.clonedSampleData = this.sampleData.map((x) => Object.assign({}, x));
        this.calculateIndexes();
        if (this.isInfiniteScroll) {
            //log
        }
        if (!this.onSearchClicked) {
            this.sortDir = 0;
            this.colName = '';
        }

      // to check whether pagination is server side or client side

      if (
        this.isClientSidePagination &&
        this.sampleData &&
        this.sampleData.length
      ) {
        this.setPage(this.currentPage);
      } else {
        //to set the current pg no.
        const data = this.sampleData.find((x) => x.pageNumber > 0);
        if (data) {
          this.currentPage = data.pageNumber;
        }

          this.itemsPerPage = this.clonedSampleData;
          
      }
    } else {
      this.sampleData = [];
      this.itemsPerPage = [];
      this.clonedSampleData = [];
      }
      
      if(this.auditTrails && this.auditTrails.length > 0) {
        this.auditTrailsOriginal = cloneDeep(this.auditTrails);
        this.auditTrailsOriginalParsed = cloneDeep(this.auditTrails).map((item) => {
          const parsedComments = (JSON.parse(item.Comments) || []).map(comment => {
            return {
              comment,
              isExistingComment: true
            }
          });

          return {
            ...item,
            IsLatest:false,
            IsNewComent: false,
            Comments: parsedComments
          }
        });
        this.auditTrailsAll = cloneDeep(this.auditTrailsOriginalParsed);
      }
  }

  /**
   * What: This function set page data
   * When: This function will execute on component load and on click of page number
   * @param page: clicked page number
   */
  public setPage(page: number, isDesc?, columnName?) {
    // if we are handling clientside pagination then "isClientSidePagination" field value will be true
    if (this.isClientSidePagination) {
      // get new page of items from items array
      this.itemsPerPage = this.clonedSampleData.slice(
        this.startIndex,
        this.endIndex + 1
        );
        
      if (!columnName) {
        if (!this.isAddSubscriptionModule) {
          window.scrollTo(0, 0);
        }
      }
    } else if (this.isInfiniteScroll){
        this.itemsPerPage = this.clonedSampleData;

    } else {

      const data = {
        "Name": $("#Name").val(),
        "Level": $("#Title").val(),
        "Email": $("#Email").val(),
        "Location": $("#Country").val(),
        "Function": $("#ServiceFunction").val(),
        "CertificationlevelID": $("#CertificationlevelID").val(),
        "SortBy": this.colName,
        "SortOrder": this.sortDir == 1 ? "DESC" : "ASC",
        "PageNumber": 1,
        "PageSize": this.pageSize
}
        
      // if we are handling serverside pagination then "isClientSidePagination" field value will be false
      const sortAndPageObj = {
        pageData: this.pagination,
        isDescending: isDesc,
        column: columnName,
        data: data
      };

      // call updateListData function in parent component
      this.handlePageChangeEvent.emit(sortAndPageObj); //for server side pagination
    }
  }

  /**
   * What: This function update the start index, end index, currentpage size
   * When: This function will execute on component load and on click of page number
   *
   */
  calculateIndexes(e?) {
    const totalRecords = this.isClientSidePagination
      ? this.sampleData.length
      : this.totalRecord;
    this.pagination = paginate(
      totalRecords,
      this.currentPage,
      this.pageSize,
      this.maxPages
      ); 
    this.currentPage = e ? this.pagination.currentPage :1; 
    this.pages = this.pagination.pages;
    this.startIndex = this.pagination.startIndex;
    this.endIndex = this.pagination.endIndex;
  }

  /**
   * What: This function set the current page and calulate the indexes for the current page
   * When: This function will execute on click of page number
   * @param page
   */
    setCurrent(e, page) { 
    e.preventDefault();
    this.currentPage = page;
    this.calculateIndexes(e);
  }

  /**
   * What: This function will fire the event and pass the clicked name to parent component
   * When: This function will execute on click of second column items
   * @param name: clicked item name
   */
  emitRegisteredEvent(rowData) {
    if (rowData) {
      this.informParentComponent.emit(rowData);
    }
  }

  handlePdfClickValue(rowData) {
    if (rowData) {
      this.emitParentPDFClickEvent.emit(rowData);
    }
  }

  emitEmailClickEvent(rowData) {
    if (rowData) {
      this.emitParentEmailClickEvent.emit(rowData);
    }
  }

  /**
   * What: This function sort the grid data either ascending order or descending order
   * When: This function will execute on click of column heading
   * @param property Column name on which sorting has applied
   */
  sortColumn(property,setDirection?) {
    if (this.oldProperty == property) {
      this.isDesc = !this.isDesc; //change the direction
    } else {
      this.oldProperty = property;
      this.isDesc = setDirection ? true :false;
    }
      const direction = this.isDesc ? 1 : -1;
      this.sortDir = direction;
      this.colName = property;
    this.clonedSampleData = this.sampleData.map((x) => Object.assign({}, x));

    this.clonedSampleData.sort(function (a, b) {
      if (a[property] != null && b[property] != null) {
        if (
          a[property] != false &&
          a[property] != true &&
          b[property] != false &&
          b[property] != true
        ) {
          if (Number(+a[property]) && Number(+b[property])) {
            if (a[property] < b[property]) {
              return -1 * direction;
            } else if (a[property] > b[property]) {
              return 1 * direction;
            } else {
              return 0;
            }
          } else if (property == 'SessionDate' || property == 'DateofSession') {
              if (new Date(a[property]).getTime() < new Date(b[property]).getTime()) {
                  return -1 * direction;
              } else if (new Date(a[property]).getTime() > new Date(b[property]).getTime()) {
                  return 1 * direction;
              } else {
                  return 0;
              }
          } else if (a[property].toLowerCase() < b[property].toLowerCase()) {
              return -1 * direction;
            } else if (a[property].toLowerCase() > b[property].toLowerCase()) {
              return 1 * direction;
            } else {
              return 0;
            }
        } else if (a[property] < b[property]) {
            return -1 * direction;
          } else if (a[property] > b[property]) {
            return 1 * direction;
          } else {
            return 0;
          }
      } else if (a[property] == null && b[property] != null) {
          return -1 * direction;
        } else if (a[property] != null && b[property] == null) {
          return 1 * direction;
        } else {
          return 0;
        }
    });
     
    this.setPage(this.currentPage, this.isDesc, property);
  }

  // below function is for subscription module
  navigateToEditPage(row) {
    //navigate to edit subscription page
    //pass data to edit page
    this.addSubscriptionService.getEditSubscription(row.ID).subscribe((res) => {
      if (res) {
        this.addSubscriptionService.editSubscriptionResponse = res;
        this.router.navigate(["/editSubscription"], {
          queryParams: { id: row.ID },
        });
      }
    });
  }

  /**
   * What: This function will toggle checked/uncheked row
   * When: This function will execute on click of checkbox of every row
   * @param rowData: is selected row data
   */
  public toggleRow(rowData): void {
    rowData.selected = !rowData.selected;
  }

  /**
   * What: This function will select/unselect all the rows
   * When: This function will execute on click of heading checkbox
   * @param event: will notify checked or unchecked value
   */
  public selectAllRows(event): void {
    const checked = event.target.checked;
    this.clonedSampleData.forEach((item) => {
      if (this.isAddSubscriptionModule) {
        if (item.IsSessionWithinSubsDates) {
          item.checked = checked;
        }
      } else {
        item.checked = checked;
      }
    });
    this.selectAllCheckbox.emit(this.clonedSampleData);
  }

  checkboxClicked(event, rowData) {
    rowData.checked = event.target.checked;
    const emailList = [];
    this.clonedSampleData.map((data) => {
      if (data.checked && data.Email) {
        emailList.push(data.Email);
      }
    });
    this.checkboxChangeEvent.emit(emailList);
  }

  clickedCheckboxAssessment(event, rowData ,index) {
    rowData.checked = event.target.checked;
    this.selectedRowIndex = rowData.checked ? index : null;
    this.informCheckboxClick.emit(rowData);
  }

  public handleActiveCheckboxValue(event, row): void {
    // handle active checkbox value
    const data = [];
    row.IsActive=!row.IsActive;
    data.push(event);
    data.push(row);
    this.checkboxChangeEvent.emit(data);
  }

  public handleEditClickValue(event, row): void {
    // handle active checkbox value
    this.editClickEvent.emit(row);
      event.preventDefault();
      const id = row.templateId ? row.templateId : null;
      
      this.router.navigate(["/manageEmailTemplate"], {
          relativeTo: this.activatedRoute,
          queryParams: { id: id },
      });
    }
    public handleEditClickSecurity(event, row): void {
        // handle active checkbox value
        this.editClickEvent.emit(row);
        event.preventDefault();
  }

    public filterSecurityData(event,columnName): void {       
      this.filterSubject.next({ event, columnName });
    }
    public redirectToAssessment(sessionName): void {
        this.assessmentService.sessionNameToRedirect = sessionName;
        setTimeout(() => {
            this.router.navigate(["/assessment"], {
                relativeTo: this.activatedRoute,
            });
        }, 1000);
        
    }

    public closeModal() {
        this.removeAuditTrails();
        this.itemsPerPage = cloneDeep(this.sampleData.map((x) => Object.assign({}, x)));
    }

    // on close of profile info modal remove existing audit trails
    public removeAuditTrails() {
      this.auditTrailsAll = [];
      this.auditTrails = [];
      this.auditTrailsOriginal = [];
      this.auditTrailsOriginalParsed = [];
      this.auditTrailsTemp = [];
    }

    public onDateChange(evt) {}

    public bc2InfoDateChange(event, row): void {
      row.Date = this.ngbToDatePipe.transform(event);
    }
  public selectAllTopics(event) {
    const value = event.target.checked;
        for (let i = 0; i < this.selectedRow.UserTopics.length; i++) {
            if (this.selectedRow.UserTopics[i].IsActive != value) {
                this.selectedRow.UserTopics[i].IsActive = value;
                this.checkAuditTrailsData(this.selectedRow.UserTopics[i].TopicName, value, this.selectedRow.UserTopics[i])
          }

            this.selectedRow.UserTopics.forEach((userTopic) => {
              if (userTopic.IsActive !== value) {
                userTopic.IsActive = value;
                this.checkAuditTrailsData(userTopic.TopicName, value, userTopic);
              }
            });
        }
    }
    public selectAllRoles(event) {
      const value = event.target.checked;
        if (!value) {
            this.selectAllTopicsCheckbox = false;
        }
        if (this.selectedRow.IsCountryAdmin === true) {
            if (this.selectedRow.IsCountryAdmin !== value) {
                this.selectedRow.IsCountryAdmin = value;
                this.checkAuditTrailsData('Country Admin', value)
            }
        }
        if (this.selectedRow.IsSubscriptionAdmin !== value) {
            this.selectedRow.IsSubscriptionAdmin = value;
            this.checkAuditTrailsData('Subscription Admin', value)
        }
        if (this.selectedRow.IsXANonGX !== value) {
            this.selectedRow.IsXANonGX = value;
            this.checkAuditTrailsData('XA(non GX)', value)
        }
        if (this.selectedRow.IsGXFacilitator !== value) {
            this.selectedRow.IsGXFacilitator = value;
            this.checkAuditTrailsData('GXFacilitator', value)
        }
        if (this.selectedRow.IsFacilitator !== value) {
            this.selectedRow.IsFacilitator = value;
            this.checkAuditTrailsData('Facilitator', value)
        }
    }
    formatStandardDate(dateReceived) {
        let formattedDate = null;
        if (dateReceived) {
            const d = new Date(dateReceived);
            formattedDate = {
                year: d.getFullYear(),
                month: d.getMonth() + 1,
                day: d.getDate(),
            };
        }
        return formattedDate;
    }
    openProfileInfoModal(modalContent: TemplateRef<any>, row) {
        this.profileFormSubmitted = false
        this.selectedRow = cloneDeep(row);
      if (this.selectedRow?.UserTopics?.length) {
        this.selectedRow.UserTopics = this.selectedRow.UserTopics.sort((a, b) =>
          a.TopicName.localeCompare(b.TopicName)
        );
      }
        this.existingCertificationDate = this.selectedRow.FundamentalCertificationDate;
        const todaysDate: Date = new Date();
        const cstDate = todaysDate.toLocaleString('en-US', { timeZone: 'America/Chicago' });
        this.maxDate = this.formatStandardDate(cstDate);
        this.emitRowSelectedEvent.emit(row);
        for (let i = 0; i < this.selectedRow.UserTopics.length; i++) {  
            if (this.selectedRow.UserTopics[i].Date) {
                this.selectedRow.UserTopics[i].IsDateExists = this.selectedRow.UserTopics[i].Date;
            }
            if (this.selectedRow.UserTopics[i].IsActive) {
                this.selectAllTopicsCheckbox = true;
            } else {
                this.selectAllTopicsCheckbox = false;
            }
        }
        if ((this.selectedRow.IsFacilitator == false && this.selectedRow.IsGXFacilitator == false && this.selectedRow.IsXANonGX == false) || this.selectedRow.CertificationlevelID != 1) {
            this.checkRolesforTopics();
        }
        
        if (this.selectedRow.IsFacilitator || this.selectedRow.IsGXFacilitator || this.selectedRow.IsXANonGX
            || this.selectedRow.IsCountryAdmin || this.selectedRow.IsSubscriptionAdmin) {
            this.selectAllRolesCheckbox = true;
        } else {
            this.selectAllRolesCheckbox = false;
        }
        if ((this.selectedRow.IsFacilitator || this.selectedRow.IsGXFacilitator || this.selectedRow.IsXANonGX) ) {
            this.disableTopics = false;
        }
        for (let i = 0; i < this.selectedRow.UserTopics.length; i++) {
            if (this.selectedRow.UserTopics[i].IsActive) {
                this.selectAllTopicsCheckbox = true;
            } else {
                this.selectAllTopicsCheckbox = false;
            }
        }
        this.disableMdrFields = this.selectedRow.PersonId ? true : false;
        this.modalService.open(modalContent, 
          { 
            size: "lg",
            backdrop: "static",
            keyboard: false,
            centered: true,
            windowClass: "profile-info-modal",
            backdropClass: "profile-info-backdrop"
          }).result.then(
          (result) => {
                  this.profileInfoData = `Closed with: ${result}`;

          },
          (error) => {
            this.profileInfoData = `Dismissed ${error}`;
          },
        );
    }
    public validateMutuallyExclusiveRoles(xa,nonGx,faci): void {
        
        if (this.selectedRow.IsXANonGX != xa && xa == false) {
            this.checkAuditTrailsData('XA(non GX)', xa)
        }
        if (this.selectedRow.IsGXFacilitator != nonGx && nonGx == false) {
            this.checkAuditTrailsData('GXFacilitator', nonGx)
        }
        if (this.selectedRow.IsFacilitator != faci && faci == false) {
            this.checkAuditTrailsData('Facilitator', faci)
        }
    }
    public checkAuditTrailsData(entity, value, row?): void {
      this.auditTrailsOriginalParsed = this.auditTrailsAll;
      switch (entity) {
        case 'Client-Certified':
          const message = (value==1) ? 'Certification: Not Client-Certified to Client Certified' : 'Certification: Client-Certified to Not Client Certified';
              this.updateAuditTrailsData(entity, message, value);
              this.selectedRow.CertificationlevelID = value;
          break;
        case 'Facilitator':
          const message1 = (value===true) ? 'Enabled Facilitator' : 'Disabled Facilitator';
          this.updateAuditTrailsData(entity, message1, value);
          this.selectedRow.IsFacilitator = value;
          break;
        case 'GXFacilitator':
          const message2 = (value===true) ? 'Enabled GX Facilitator' : 'Disabled GX Facilitator';
          this.updateAuditTrailsData(entity, message2, value);
          this.selectedRow.IsGXFacilitator = value;
          break;
        case 'XA(non GX)':
          const message3 = (value===true) ? 'Enabled XA(non GX)' : 'Disabled XA(non GX)';
          this.updateAuditTrailsData(entity, message3, value);
          this.selectedRow.IsXANonGX = value;
          break;
        case 'Subscription Admin':
          const message4 = (value===true) ? 'Enabled Subscription Admin' : 'Disabled Subscription Admin';
          this.updateAuditTrailsData(entity, message4, value);
          this.selectedRow.IsSubscriptionAdmin = value;
          break;
        case 'Country Admin':
          const message5 = (value===true) ? 'Enabled Country Admin' : 'Disabled Country Admin';
          this.updateAuditTrailsData(entity, message5, value);
          this.selectedRow.IsCountryAdmin = value;
          break;
        case 'Activate Team Chemistry':
          const message6 = (value === true) ? `Enabled BC 2.0: ${entity}` : `Disabled BC 2.0: ${entity}`;  
          this.updateAuditTrailsData(entity, message6, value);
          break;
        case 'Approaching Problems Differently for Breakthrough':
          const message7 = (value === true) ? `Enabled BC 2.0: ${entity}` : `Disabled BC 2.0: ${entity}`; 
          this.updateAuditTrailsData(entity, message7, value);
          break;
        case 'Trust Fall': 
          const message8 = (value === true) ? `Enabled BC 2.0: ${entity}` : `Disabled BC 2.0: ${entity}`; 
          this.updateAuditTrailsData(entity, message8, value);
          break;
        case 'Stress Test':
          const message9 = (value === true) ? `Enabled BC 2.0: ${entity}` : `Disabled BC 2.0: ${entity}`;
          this.updateAuditTrailsData(entity, message9, value);
          break;
        case 'Teaming Differently for Breakthrough':
          const message10 = (value === true) ? `Enabled BC 2.0: ${entity}` : `Disabled BC 2.0: ${entity}`;
          this.updateAuditTrailsData(entity, message10, value);
          break;

          default:
            break;
      }
      this.auditTrailsAll = this.auditTrailsOriginalParsed.concat(this.auditTrailsTemp);
      this.auditTrailsTemp = [];
      if (this.selectedRow.IsFacilitator || this.selectedRow.IsGXFacilitator || this.selectedRow.IsXANonGX
            || this.selectedRow.IsCountryAdmin || this.selectedRow.IsSubscriptionAdmin) {
            this.selectAllRolesCheckbox = true;
        } else {
            this.selectAllRolesCheckbox = false;
      }
      let count = 0;
        for (let i = 0; i < this.selectedRow.UserTopics.length; i++) {
            if (this.selectedRow.UserTopics[i].TopicName == entity) {
                this.selectedRow.UserTopics[i].IsActive = value;
            }
            if(this.selectedRow.UserTopics[i].IsActive){
                count++;
            }
        }
      if (count == this.selectedRow.UserTopics.length) {
            this.selectAllTopicsCheckbox = true;
        } else {
            this.selectAllTopicsCheckbox = false;
        }
        
      this.checkRolesforTopics();
        
    }
    checkRolesforTopics() { 
        for (let i = 0; i < this.selectedRow.UserTopics.length; i++) { 
            if (!this.selectedRow.UserTopics[i].IsDateExists && !this.selectedRow.UserTopics[i].IsActive) {
                this.selectedRow.UserTopics[i].Date = null; 
            }
        }
        if ((this.selectedRow.IsFacilitator == false && this.selectedRow.IsGXFacilitator == false && this.selectedRow.IsXANonGX == false)) {
            this.disableTopics = true;
            this.selectAllTopicsCheckbox = false;
            for (let i = 0; i < this.selectedRow.UserTopics.length; i++) {
                this.selectedRow.UserTopics[i].IsActive = false;  
            }
        }
        else {
            this.disableTopics = false;
        }
    }
    public updateAuditTrailsData(entity, message, value): void {
      if(this.auditTrailsTemp.length > 0) {
        if(this.auditTrailsTemp.some((item) => item.FieldName === entity)) {
          this.auditTrailsTemp = this.auditTrailsTemp.filter((item) => item.FieldName !== entity);
        } else {
          this.pushToAuditTrailsArray(entity, message, value);
        }
      } else {
        this.pushToAuditTrailsArray(entity, message, value);
      }
    }

  pushToAuditTrailsArray(entity, message, value): void {

    // convert value of isclientcertified i.e. number to booleen
    // based on boolean value, required error message will be enabled for the audit message
    if (value == 1) {
      value = true;
    }
    else if (value == 2) {
      value = false;
    }

    // Convert the date to CST
    const todaysDate: Date = new Date();
    const cstDate = todaysDate.toLocaleString('en-US', { timeZone: 'America/Chicago' });
    this.auditTrailsTemp.push({
      ID: 0,
      UserId: this.loggedInUserDetails.LoggedInUserId,
      CreatedDate: cstDate,
      FieldName: entity,
      AuditTrail: message,
      Comments: [{ comment: '', isExistingComment: false }],
      CreatedBy: this.loggedInUserDetails.FirstName + ' ' + this.loggedInUserDetails.LastName,
      IsLatest: true,
      IsNewComent: true,
      IsEnabled: value
    });
  }

    addNewComment(row) {
      row.Comments.push({
        comment: '',
        isExistingComment: false
      });
      row.IsLatest = true;
    }

    profileInfoSubmit(formData): void { 
        this.profileFormSubmitted = true;
        document.getElementsByClassName('ng-invalid')[1]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if(formData.valid) {
          const modifiedAuditTrails = cloneDeep(this.auditTrailsAll).filter(t=>t.IsLatest===true).map((item) => {
            const nameAppendedComments = item.Comments.filter(c => c.comment != '').map(commentItem => {

              let formattedComment = '';
              if (commentItem.isExistingComment) {
                formattedComment = commentItem.comment;
              }
              else {
                formattedComment = (commentItem.comment === '' || commentItem.comment === undefined) ?
                  commentItem.comment : (this.loggedInUserDetails.FirstName + ' ' + this.loggedInUserDetails.LastName + ' - ' + commentItem.comment);
              }
            
              return formattedComment;
            });
            return {
              ...item,
              Comments: JSON.stringify(nameAppendedComments || [''])
            }
          });
          const data: any = {
            Name: formData.value.Name,
            Email: formData.value.Email,
            CountryID: this.selectedRow.CountryID,
            LevelID: this.selectedRow.LevelID,
            ServiceFunctionID: this.selectedRow.ServiceFunctionID,
            CertificationlevelID: formData.value.CertificationlevelID,
            IsFacilitator: formData.value.IsFacilitator,
            IsGXFacilitator: formData.value.IsGXFacilitator,
            IsXANonGX: formData.value.IsXANonGX,
            IsSubscriptionAdmin: formData.value.IsSubscriptionAdmin,
            IsCountryAdmin: this.selectedRow.IsCountryAdmin,
            IsActive: this.selectedRow.IsActive,
            IsBC2: this.selectedRow.IsBC2,
            FundamentalCertificationDate: this.ngbToDatePipe.transform(formData.value.FundamentalCertificationDate),
            AuditTrails: modifiedAuditTrails,
            UserTopics:this.selectedRow.UserTopics
          };
          this.securityService.saveUserDetails(data).subscribe(res => {
              this.onProfileInfoSave.emit(res);
              this.removeAuditTrails();
              this.userRoleService.getUserRoles().subscribe(res => {
                  this.userRoleService.setUserRoleList(res.Roleid);
              });
          });
          this.modalService.dismissAll();
        } 
    }
    changeToPrevious(control,valueCheck=1):void
    {
      if (valueCheck == 1) {
      control.control.setValue(this.dateToNgbPipe.transform(this.existingCertificationDate));
      }
    }
}
